// Module
var code = "<input auto-numeric-input ng-model=\"model[options.key]\" class=\"form-control\" decimal-places=\"to.decimalPlaces\" maximum-value=\"to.maximumValue\" minimum-value=\"to.minimumValue\" read-only=\"to.readOnly\" up-down-step=\"to.step\"/> ";
// Exports
export default code;